<template>
  <div style="background-color: white">
    <div class="search-block" style="padding-top: 10px;margin-top: 0">
      <DxTextBox
          :show-clear-button="true"
          placeholder="请输入企业名称"
          @valueChanged="onCompanyNameValueChange"
      />

      <DxSelectBox
          :items="industryTips"
          placeholder="请选择行业"
          width="250"
          @opened="handleIndustryClick"
          ref="selectBoxRef"
          :value="industryTips[0]"
      />

      <DxSelectBox
          :items="provinces"
          placeholder="请选择省份"
          :show-clear-button="true"
          @valueChanged="onProvinceChange"
          width="150"
      />

      <DxSelectBox
          :items="city"
          placeholder="请选择城市"
          :show-clear-button="true"
          @valueChanged="onCityChange"
          width="150"
      />

      <DxSelectBox
          :data-source="lpPhoneSelect"
          placeholder="分值"
          :show-clear-button="true"
          display-expr="text"
          value-expr="value"
          @valueChanged="onMarkChange"
          width="150"
      />

      <DxSelectBox
          :data-source="taxGradeSelect"
          placeholder="纳税等级"
          :show-clear-button="true"
          display-expr="text"
          value-expr="value"
          @valueChanged="onTaxGradeChange"
          width="150"
      />

      <DxButton
          :width="100"
          text="搜索"
          type="success"
          styling-mode="contained"
          @click="initSearch"
          class="search-block-btn"
      />
      <div style="margin-top: 15px">
        <span>结果数量：{{total === 1000000 ? '1000000+' : total}}</span>
      </div>

    </div>

    <div class="search-block">
      <DxTextBox
          :show-clear-button="true"
          placeholder="导出数量"
          @valueChanged="onExportNumValueChange"
      />

      <DxSelectBox
          :data-source="buySelect"
          placeholder="只导出未解锁"
          :show-clear-button="true"
          display-expr="text"
          value-expr="value"
          @valueChanged="onHasBuyChange"
      />

      <DxButton
          :width="100"
          text="导出"
          type="default"
          styling-mode="contained"
          @click="downloadsList"
          class="search-block-btn"
      />

      <DxButton
          :width="150"
          text="导出当前查询结果"
          type="default"
          styling-mode="contained"
          @click="downloadsCurrentList"
          class="search-block-btn"
      />

      <div style="margin-top: 15px">
        <span>已解锁数量：{{purchaseCount}}</span>
      </div>
    </div>

    <dx-data-grid :data-source="info"   ref="dataGrid" id="dataGrid" height="540"
                  :show-borders="true" :focused-row-enabled="true"
                  :hover-state-enabled="true" :allowColumnResizing="true" :allowColumnReordering="true"
                  key-expr="id" :selected-row-keys="selectedItemKeys"
                  @selection-changed="selectionChanged"
                  columnReorderingMode="widget"
                  columnResizingMode="widget"
                  :column-auto-width="true">
      <dx-column data-field="companyName" data-type="string" caption="企业名称"  alignment="center" :allowSorting="false"/>
      <dx-column data-field="legalPerson" caption="法定代表人" data-type="string" alignment="center" :allowSorting="false"/>
      <dx-column data-field="lpPhone" caption="联系方式" data-type="string" alignment="center" :allowSorting="false" cell-template="lpPhoneCell" />
      <template #lpPhoneCell="{data}">
        <span style="color: blue;" @click="beforeViewPhone(data)" v-if="data.data.lpPhone != null && data.data.lpPhone.length === 0 ">点击查看</span>
        <span v-else-if="data.data.lpPhone != null && data.data.lpPhone.length !== 0 ">{{data.data.lpPhone}}</span>
        <span style="color: #c4c4c4;" v-else>暂无联系方式</span>
      </template>
      <dx-column data-field="mark" caption="分值" data-type="string"  alignment="center" :allowSorting="false"/>
      <dx-column data-field="creditCode" caption="统一社会信用代码" data-type="string"  alignment="center" :allowSorting="false"/>
      <dx-column data-field="taxGrade" caption="纳税等级" data-type="string"  alignment="center" :allowSorting="false"/>
      <dx-column data-field="province" caption="所属省份"  data-type="string" alignment="center" :allowSorting="false"/>
      <dx-column data-field="city" caption="所属城市" data-type="string" alignment="center" :allowSorting="false" :maxWidth="150"/>
      <dx-column data-field="industry" caption="行业" data-type="date"  alignment="center" format="yyyy-MM-dd" :allowSorting="false"/>
      <dx-column data-field="factCapital" caption="注册资金" data-type="string" alignment="center" :allowSorting="false" :maxWidth="150"/>

      <DxColumnFixing :enabled="true"/>
<!--      <DxColumnChooser :enabled="true" :allow-search="true" mode="select" :height="500" />-->
      <DxLoadPanel :enabled="true"/>
      <dx-paging :enabled="false"/>

<!--      <DxToolbar>-->
<!--        <DxItem location="before" template="refreshTemplate"/>-->
<!--        <DxItem location="before" template="chooserTemplate"/>-->
<!--      </DxToolbar>-->

      <template #refreshTemplate>
        <DxButton icon="refresh" @click="getList(true)"/>
      </template>

      <template #chooserTemplate>
        <dx-button @click="columnChooserClick()" >
          <i class="dx-icon dx-icon-column-chooser"></i>
        </dx-button>
      </template>
      <template #textTemplate="{data }">
        <div>
          <DxTextArea  :hint="data.value" v-model:value="data.value" :height="30" :readOnly="true" />
        </div>
      </template>
      <!-- 标签选择组件-->
      <template #dropTemplate="{ data }">
        <div style="height: 25px;align-items: center;display: flex;">
          <DxTagBox  width="100%" :items="simpleProducts" :value="data.value" :multiline="false" :search-enabled="true"
                     @value-changed="h"/>
        </div>
      </template>
    </dx-data-grid>

    <el-pagination align="center" @size-change="sizeChange" @current-change="currentChange" :page-sizes="pageSizes" :page-size="query.pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="total" background>
    </el-pagination>

    <DxPopup
        content-template="popup-content"
        :visible="isDeductPopupVisible"
        :close-on-outside-click="false"
        :width="300"
        :height="100"
        :drag-enabled="false"
        :show-title="false"
    >
      <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="confirmButtonOptions"
      />

      <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="closeButtonOptions"
      />

      <template #popup-content>
        <div>
          <span>查看需要扣除{{selectCellInfo.point}}点积分，是否确认查看？</span>
        </div>
      </template>
    </DxPopup>

    <IndustrySelector
        @selectChange="onIndustryValueChange"
        ref="IndustrySelector"
        :visible="isIndustryPopupVisible"
        @confirm="isIndustryPopupVisible = false"
        @cancel="isIndustryPopupVisible = false"
    ></IndustrySelector>
  </div>
</template>

<script>
import axios from 'axios';

import provinces from "@/js/area"
import { years, months } from "@/js/year"
import nationalStandardIndustryCategories from "@/js/industryCategories"
import IndustrySelector from "@/components/IndustrySelector.vue";

export default {
  components: {IndustrySelector},
  data() {
    return {
      upload:false,
      add: false,
      update:false,
      label:false,
      labelSet:false,
      selectedItemKeys: [],
      selectionChanged: (data) => {
        this.selectedItemKeys = data.selectedRowKeys;
      },
      pageSizes:[10, 20, 50, 100,200],
      query:{
        companyName: '',
        industry: '',
        province: '',
        city: '',
        mark: null,
        registerTime: '',
        exportNum: 0,
        exportSkip: 0,
        needPhone: false,
        taxGrade: '',
        hasBuy: false,
        currentPage: 1,
        pageSize: 10
      },
      total:1000000,
      info: [],
      wechatNameSelect: [],
      simpleProducts: [
      ],
      index:0,
      provinces: [],
      city: [],
      industry: [],
      industryTips: [],
      lpPhoneSelect: [
        {value: 'A', text: 'A'},
        {value: 'B', text: 'B'},
      ],
      buySelect: [
        {value: true, text: '未解锁'},
      ],
      taxGradeSelect: [
        {value: 'A', text: 'A'},
        {value: '非A', text: '非A'},
        {value: '一般纳税人', text: '一般纳税人'},
      ],
      years: [],
      months: [],
      isDeductPopupVisible: false,
      closeButtonOptions: {
        text: '关闭',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: () => {
          this.isDeductPopupVisible = false;
        },
      },
      confirmButtonOptions: {
        text: '确定',
        stylingMode: 'outlined',
        onClick: () => {
          this.viewPhone()
        },
      },
      selectCellInfo: {},
      purchaseCount: 0,
      isIndustryPopupVisible: false,
    };
  },
  created() {
    this.getList(false)
    this.initSelect()
    this.countPurchase()
  },
  methods:{
    initSelect(){
      const keys = [];
      for(var key in provinces) {
        keys.push(key)
      }

      this.provinces = keys
      this.years = years

      this.industry = nationalStandardIndustryCategories
    },
    countPurchase(){
      this.$http.countPurchase({dataType: 3}).then(res => {
        this.purchaseCount = res.data
      })
    },
    columnChooserClick() {
      this.$refs.dataGrid.instance.showColumnChooser();
    },
    sizeChange(val){
      this.query.pageSize=val
      this.getList(false)
    },
    currentChange(val){
      this.query.currentPage=val
      this.getList(false)
    },
    getList(hasCount){
      this.$http.searchTaxpayer(this.query).then(res => {
        this.info = res.data
      });
      if(hasCount) {
        this.countSearchResult();
      }
    },
    countSearchResult(){
      this.total = '正在统计...'
      this.$http.countSearchTaxpayer(this.query).then(res => {
        const count = res.data
        this.total = count >= 1000000 ? 1000000 : count
      })
    },
    openUpdate(){
      if(this.selectedItemKeys.length==1){
        this.update=true
      }else if(this.selectedItemKeys.length==0){
        this.$message({type: 'warning', message: '最少选中一条数据!', center: true});
      }else {
        this.$message({type: 'warning', message: '请单选数据!', center: true});
      }

    },
    h(e){
      this.$http.CustomerEdit({"id":this.selectedItemKeys[0],"label":e.value.toString()}).then(res=>{
        if(res.status == "success"){
          this.$message({type: 'success', message: '修改标签成功', center: true});
          this.getList(false)
        }else {
          this.$message({type: 'error', message: '修改失败', center: true});
        }
      })
    },
    downloadsList(){
      if(!this.query.exportNum) {
        this.$message({type: 'error', message: "请输入导出数量", center: true});
        return;
      }

      this.query.exportSkip = 0

      this.$confirm('此操作将导出'+this.query.exportNum+'条数据,如数据较多可能耗时较长，等待期间请勿进行其他操作，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {

        axios.post(this.$address+"taxpayer/exportData",this.query, {responseType: 'blob', token:localStorage.getItem("token"), timeout: 0})
            .then(response=>{
              const url = window.URL.createObjectURL(new Blob([response.data],{type:'application/vnd.ms-excel'}));
              const link = document.createElement('a');
              link.href = url;
              link.download = '数据导出.xlsx';
              document.body.appendChild(link);
              link.click();
            }).catch((error) => {
          this.$message({type: 'error', message: "余额不足", center: true});
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消!', center: true});
      });

    },
    downloadsCurrentList(){
      const currentPage = this.query.currentPage
      const pageSize = this.query.pageSize

      this.query.exportNum = this.info.length
      this.query.exportSkip = (currentPage - 1) * pageSize

      this.$confirm('此操作将导出'+this.query.exportNum+'条数据，如数据较多可能耗时较长，等待期间请勿进行其他操作，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {

        axios.post(this.$address+"taxpayer/exportData",this.query, {responseType: 'blob', token:localStorage.getItem("token"), timeout: 0})
            .then(response=>{
              const url = window.URL.createObjectURL(new Blob([response.data],{type:'application/vnd.ms-excel'}));
              const link = document.createElement('a');
              link.href = url;
              link.download = '数据导出.xlsx';
              document.body.appendChild(link);
              link.click();
            }).catch((error) => {
          this.$message({type: 'error', message: "余额不足", center: true});
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消!', center: true});
      });
    },
    onCompanyNameValueChange(e){
      this.query.companyName = e.value
    },
    onIndustryValueChange(values){
      this.query.industry = values.join(";")
      this.industryTips = values.length === 0 ? [] : [`已选择${values.length}个`]
    },
    onProvinceChange(e){
      this.query.province = e.value
      this.city = provinces[e.value]
    },
    onCityChange(e){
      this.query.city = e.value
    },
    onMarkChange(e) {
      this.query.mark = e.value
    },
    onHasBuyChange(e) {
      this.query.hasBuy = e.value === true
    },
    onTaxGradeChange(e) {
      this.query.taxGrade = e.value
    },
    onExportNumValueChange(e) {
      this.query.exportNum = e.value
    },
    initSearch(){
      this.query.currentPage = 1
      this.getList(true)
    },
    beforeViewPhone(cellInfo) {
      this.selectCellInfo = cellInfo
      const mark = cellInfo.data.mark
      switch (mark) {
        case 'A':
          this.selectCellInfo.point = 1;
          break
        case 'B':
          this.selectCellInfo.point = 4;
          break
        default:
          this.$message({type: 'error', message: '分值错误', center: true});
          return
      }
      this.isDeductPopupVisible = true
    },
    viewPhone(){
      const cellInfo = this.selectCellInfo

      this.$http.viewLpPhoneTaxpayer({mid: cellInfo.data.id}).then(res => {
        if (res.status === 'success'){
          let data = cellInfo.data
          data.lpPhone = res.data
          this.info.splice(cellInfo.rowIndex, data)

          this.isDeductPopupVisible = false
        }else {
          this.$message({type: 'error', message: res.msg, center: true});
        }


        // console.log(res)
      })
    },
    handleIndustryClick(event){
      event.component.close()
      this.isIndustryPopupVisible = true
    }
  }
};
</script>
<style>

.search-block {
  display: flex;
  gap: 10px;
  margin: 5px 0 5px 5px;
}

.search-block-btn {
  margin-top: 8px;
}

.dx-overlay-wrapper.dx-datagrid-column-chooser {
  height: 5px !important;
}
.dx-overlay-content.dx-popup-normal.dx-popup-draggable.dx-resizable {
  top: -50px !important;
  left: auto !important;
  right: 0;
  transform: translate(0, 0) !important;

}
.group{
  z-index:999 ;

}


.dx-viewport .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff5722;
  color: #FFF !important;
}
.el-pager li:hover {
  background-color: #ff5722;
  color: #ff5722 !important;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}
</style>
